(() => {
  const root = document.querySelector('[data-sw-product]');
  if (!root) return;

  const variants = JSON.parse(root.querySelector('[data-sw-variants]').textContent);
  const bundles  = root.querySelector('[data-sw-bundles]');
  const clock    = root.querySelector('[data-sw-clock]');
  const heroImg  = root.querySelector('#sw-gal-hero');

  /* --- galeri --- */
  root.querySelectorAll('.sw-gal__thumb').forEach(btn => {
    btn.addEventListener('click', () => {
      root.querySelectorAll('.sw-gal__thumb').forEach(t => t.classList.remove('is-active'));
      btn.classList.add('is-active');
      heroImg.classList.add('is-swapping');
      const next = new Image();
      next.onload = () => {
        heroImg.removeAttribute('srcset');
        heroImg.removeAttribute('sizes');
        heroImg.src = next.src;
        heroImg.classList.remove('is-swapping');
      };
      next.src = btn.dataset.full;
    });
  });

  /* --- kök renk pilleri --- */
  const pills = root.querySelectorAll('[data-sw-root-color] .sw-pill');
  const availablePills = () => [...pills].filter(pill => !pill.disabled && pill.dataset.available !== 'false');
  const rootColor = () => (root.querySelector('.sw-pill.is-on') || availablePills()[0])?.dataset.color || '';
  pills.forEach(p => p.addEventListener('click', () => {
    if (p.disabled || p.dataset.available === 'false') return;
    pills.forEach(x => { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
    p.classList.add('is-on'); p.setAttribute('aria-checked', 'true');
    root.querySelectorAll('[data-sw-item-color]').forEach(sel => { sel.value = p.dataset.color; syncThumb(sel); });
    const selectedVariant = variants[p.dataset.color];
    if (selectedVariant?.img && heroImg) {
      heroImg.classList.add('is-swapping');
      const next = new Image();
      next.onload = () => {
        heroImg.removeAttribute('srcset');
        heroImg.removeAttribute('sizes');
        heroImg.src = next.src;
        heroImg.classList.remove('is-swapping');
      };
      next.src = selectedVariant.img;
    }
  }));
  const initialPill = root.querySelector('.sw-pill.is-on') || availablePills()[0];
  if (initialPill && !root.querySelector('.sw-pill.is-on')) {
    initialPill.classList.add('is-on');
    initialPill.setAttribute('aria-checked', 'true');
  }

  /* --- paket seçimi --- */
  bundles.querySelectorAll('.sw-bundle').forEach(card => {
    card.addEventListener('click', () => {
      bundles.querySelectorAll('.sw-bundle').forEach(c => {
        c.classList.remove('is-on');
        const r = c.querySelector('input[type=radio]'); if (r) r.checked = false;
      });
      card.classList.add('is-on');
      const r = card.querySelector('input[type=radio]'); if (r) r.checked = true;
    });
  });
  root.querySelectorAll('[data-sw-item-color]').forEach(sel => {
    sel.addEventListener('change', () => syncThumb(sel));
    sel.addEventListener('click', e => e.stopPropagation());
    syncThumb(sel);
  });
  function syncThumb(sel) {
    const v = variants[sel.value];
    const img = sel.closest('.sw-row')?.querySelector('.sw-row__thumb');
    if (v && img && (v.thumb || v.img)) img.src = v.thumb || v.img;
  }

  /* --- geri sayım (oturum boyunca korunur) --- */
  const total = (parseInt(root.dataset.countdown, 10) || 15) * 60;
  const key = 'sw-clock-' + root.dataset.productHandle;
  let end = parseInt(sessionStorage.getItem(key), 10);
  if (!end || end < Date.now()) { end = Date.now() + total * 1000; sessionStorage.setItem(key, end); }
  const tick = () => {
    let left = Math.round((end - Date.now()) / 1000);
    if (left <= 0) { end = Date.now() + total * 1000; sessionStorage.setItem(key, end); left = total; }
    clock.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
  };
  tick(); setInterval(tick, 1000);

  /* --- sepete ekleme --- */
  function buildItems() {
    const card = bundles.querySelector('.sw-bundle.is-on') || bundles.querySelector('.sw-bundle');
    const qty = parseInt(card.dataset.qty, 10) || 1;
    const group = 'sw-' + Date.now();
    const itemSelectors = [...card.querySelectorAll('[data-sw-item-color]')];
    const colors = itemSelectors.length ? itemSelectors.map(s => s.value) : [rootColor()];
    const items = colors.map((c, i) => {
      const v = variants[c];
      if (!v || !v.available) return null;
      return {
        id: v.id,
        quantity: 1,
        properties: {
          'Cüzdan Rengi': c,
          'pmpr_cart_item': group,
          [`${i + 1}. Cüzdan Rengi`]: c
        }
      };
    }).filter(Boolean);
    return items.length === qty ? items : [];
  }

  const busy = (btn, on) => btn.classList.toggle('is-busy', on);
  const easySellButton = root.querySelector('[data-sw-easysell-trigger]');
  const easySellForm = root.querySelector('[data-sw-product-form]');
  const easySellError = root.querySelector('[data-sw-easysell-error]');

  async function openEasySellForm(button) {
    busy(button, true);
    button.disabled = true;
    if (easySellError) easySellError.hidden = true;
    try {
      const items = buildItems();
      if (!items.length) throw new Error('Lütfen cüzdan rengini seçin.');

      window.pmpr_cart_item = items;
      window.ES_CLOSEST_FORM = easySellForm;
      const variantInput = easySellForm?.querySelector('[data-sw-variant-id]');
      const quantityInput = easySellForm?.querySelector('[data-sw-quantity]');
      if (variantInput) variantInput.value = items[0].id;
      if (quantityInput) quantityInput.value = items.length;

      for (let attempt = 0; attempt < 60; attempt += 1) {
        if (typeof window.openTysloForm === 'function') {
          try {
            const opening = window.openTysloForm();
            Promise.resolve(opening).catch(error => console.error('[SW EasySell] App response:', error));
            return;
          } catch (error) {
            console.error('[SW EasySell] Direct open failed:', error);
          }
        }
        const appButton = root.querySelector('.es-popup-button-product, #es-popup-button')
          || document.querySelector('.es-popup-button-product, #es-popup-button');
        if (appButton && appButton !== button) {
          appButton.click();
          return;
        }
        await new Promise(resolve => window.setTimeout(resolve, 100));
      }
      throw new Error('EasySell sipariş formu yüklenemedi. Lütfen tekrar deneyin.');
    } catch (err) {
      console.error('[SW EasySell] Form could not be opened:', err);
      if (easySellError) {
        easySellError.textContent = err?.message || 'Sipariş formu açılamadı.';
        easySellError.hidden = false;
      }
    } finally {
      button.disabled = false;
      busy(button, false);
    }
  }

  easySellButton?.addEventListener('click', event => {
    event.preventDefault();
    openEasySellForm(event.currentTarget);
  });

  /* --- paylaş --- */
  root.querySelector('[data-sw-share]').addEventListener('click', async () => {
    const data = { title: document.title, url: location.href.split('?')[0] };
    if (navigator.share) { try { await navigator.share(data); } catch (_) {} }
    else { await navigator.clipboard?.writeText(data.url); }
  });
})();
